<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'docversion.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteDocVersion()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['docVersion'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteDocVersion() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('docVersion/delete', this.docVersion.id);
          this.$store.dispatch('docVersion/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateAppVersion() {
        this.$router.push('/users/categories/update/' + this.docVersion.id);
      }
    }
  };
</script>
